// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607201533/js/" + chunkId + "." + {"44":"0c464491","225":"b0c544b6","481":"9087ac0f","486":"cfab7045","770":"f18ab15e"}[chunkId] + ".0.3551842207428716.chunk.js";
};